import { Controller } from "@hotwired/stimulus"

// Controller for collapsible fleet sections in the calendar
// Handles toggle state and localStorage persistence
export default class extends Controller {
  static targets = ["icon", "content"]
  static values = { sectionId: String }

  connect() {
    this.storageKey = "fleet_calendar_section_states"
    this.restoreState()
  }

  toggle(event) {
    // Prevent toggle when clicking on links inside the header
    if (event.target.closest("a")) {
      return
    }

    const content = this.contentTarget
    const icon = this.iconTarget
    const isHidden = content.classList.contains("hidden")

    if (isHidden) {
      content.classList.remove("hidden")
      icon.classList.remove("-rotate-90")
    } else {
      content.classList.add("hidden")
      icon.classList.add("-rotate-90")
    }

    this.saveState(!isHidden)
  }

  restoreState() {
    const states = this.loadStates()
    const isCollapsed = states[this.sectionIdValue]

    if (isCollapsed) {
      this.contentTarget.classList.add("hidden")
      this.iconTarget.classList.add("-rotate-90")
    }
  }

  saveState(isCollapsed) {
    const states = this.loadStates()
    states[this.sectionIdValue] = isCollapsed
    localStorage.setItem(this.storageKey, JSON.stringify(states))
  }

  loadStates() {
    try {
      const stored = localStorage.getItem(this.storageKey)
      return stored ? JSON.parse(stored) : {}
    } catch (_e) {
      return {}
    }
  }
}
